// src/Routes.js
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from './containers/HomePage';
import CompetitionOverviewContainer from './containers/CompetitionOverviewContainer';
import CompetitionRulesContainer from './containers/CompetitionRulesContainer';
import CompetitionStatistics from './containers/CompetitionStatisticsContainer';
import RecentActivities from './containers/RecentActivitiesOverview';
import LoginPage from './containers/LoginPage';
import PrivateRoute from './PrivateRoute';
import UserProfile from './containers/UserProfile';
import RegisterActivityPage from './containers/RegisterActivityPage';

const RoutesConfig = () => (
    <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/rules" element={<CompetitionRulesContainer />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Private routes */}
        <Route path="/overview" element={<PrivateRoute />}>
            <Route index element={<CompetitionOverviewContainer />} />
        </Route>
        <Route path="/statistics" element={<PrivateRoute />}>
            <Route index element={<CompetitionStatistics />} />
        </Route>
        <Route path="/recentactivities" element={<PrivateRoute />}>
            <Route index element={<RecentActivities />} />
        </Route>
        <Route path="/profile/:username" element={<PrivateRoute />}>
            <Route index element={<UserProfile />} />
        </Route>
        <Route path="/activity" element={<PrivateRoute />}>
            <Route index element={<RegisterActivityPage />} />
        </Route>
    </Routes>
);

export default RoutesConfig;
